/**
 * Veluna Base Theme - Main JavaScript
 * Optimized for Shopify editor (iframe) and production
 */

(function() {
  'use strict';

  // Detect if we're in Shopify editor iframe
  var isInIframe = window.self !== window.top || window.location !== window.parent.location;
  var isShopifyEditor = window.Shopify && window.Shopify.designMode || 
                        window.parent !== window && 
                        (window.parent.location.hostname.includes('myshopify.com') || 
                         window.parent.location.hostname.includes('shopify.com'));

  // Initialize theme when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // ===== STICKY HEADER (iframe-safe) =====
    var header = document.querySelector('.veluna-header');
    if (header) {
      // If in iframe (Shopify editor), use fixed positioning
      if (isInIframe || isShopifyEditor) {
        header.style.position = 'fixed';
        header.style.top = '0';
        header.style.left = '0';
        header.style.right = '0';
        header.style.width = '100%';
        header.style.zIndex = '1000';
        
        // Add padding to body to prevent content jump
        var headerHeight = header.offsetHeight;
        document.body.style.paddingTop = headerHeight + 'px';
      }
      
      var handleScroll = function() {
        var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        if (scrollY > 10) {
          header.classList.add('veluna-header--scrolled');
        } else {
          header.classList.remove('veluna-header--scrolled');
        }
      };
      
      // Check initial scroll position
      handleScroll();
      
      // Listen for scroll events (throttled for performance)
      var ticking = false;
      var scrollHandler = function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };
      
      // Use appropriate scroll target (iframe vs window)
      var scrollTarget = isInIframe ? document : window;
      scrollTarget.addEventListener('scroll', scrollHandler, { passive: true });
    }
    
    // ===== EXIT INTENT POPUP (iframe-safe, consolidated) =====
    var popup = document.querySelector('.veluna-email-popup');
    if (popup) {
      var shownKey = 'velunaEmailPopupShown';
      var hasShown = false;
      
      // Try to get from sessionStorage (may fail in iframe)
      try {
        hasShown = sessionStorage.getItem(shownKey) === 'true';
      } catch (e) {
        // Fallback to localStorage if sessionStorage blocked
        try {
          hasShown = localStorage.getItem(shownKey + '_session') === 'true';
        } catch (e2) {
          console.warn('Storage not available');
        }
      }

      var showPopup = function(trigger) {
        try {
          if (sessionStorage.getItem(shownKey) === 'true') return;
        } catch (e) {
          try {
            if (localStorage.getItem(shownKey + '_session') === 'true') return;
          } catch (e2) {}
        }
        
        popup.setAttribute('aria-hidden', 'false');
        popup.classList.add('veluna-email-popup--visible');
        
        // Store shown state
        try {
          sessionStorage.setItem(shownKey, 'true');
        } catch (e) {
          try {
            localStorage.setItem(shownKey + '_session', 'true');
          } catch (e2) {}
        }
        
        // Track popup shown (if analytics available)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'popup_shown', {
            event_category: 'email_capture',
            event_label: trigger || 'auto'
          });
        }
      };

      var hidePopup = function() {
        popup.setAttribute('aria-hidden', 'true');
        popup.classList.remove('veluna-email-popup--visible');
      };

      // Close handlers (X button or backdrop)
      popup.addEventListener('click', function(event) {
        if (event.target.hasAttribute('data-email-popup-close') ||
            event.target.closest('[data-email-popup-close]')) {
          hidePopup();
        }
      });

      if (!hasShown) {
        // Exit-intent detection (iframe-safe)
        var exitIntentDetected = false;
        
        // Method 1: Mouse leaves top of viewport (works in iframe)
        var handleMouseLeave = function(event) {
          if (exitIntentDetected) return;
          
          // Check if mouse is leaving top of viewport
          if (event.clientY <= 5 && event.relatedTarget === null) {
            exitIntentDetected = true;
            showPopup('exit_intent');
            document.removeEventListener('mouseleave', handleMouseLeave);
          }
        };
        
        // Method 2: Mouseout (fallback)
        var handleMouseOut = function(event) {
          if (exitIntentDetected) return;
          
          if (!event.toElement && !event.relatedTarget && event.clientY <= 0) {
            exitIntentDetected = true;
            showPopup('exit_intent');
            window.removeEventListener('mouseout', handleMouseOut);
          }
        };
        
        // Method 3: Before unload (last chance)
        var handleBeforeUnload = function() {
          if (!exitIntentDetected && !hasShown) {
            // Show popup as user is leaving
            showPopup('before_unload');
          }
        };
        
        // Attach all exit intent handlers
        document.addEventListener('mouseleave', handleMouseLeave);
        window.addEventListener('mouseout', handleMouseOut);
        window.addEventListener('beforeunload', handleBeforeUnload);
        
        // Fallback: Time-based trigger (reduced for editor testing)
        var timeDelay = isShopifyEditor ? 5000 : 20000; // 5s in editor, 20s in production
        setTimeout(function() {
          if (!exitIntentDetected) {
            showPopup('timer');
          }
        }, timeDelay);
      }
    }
    
    // ===== LAZY LOADING IMAGES =====
    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.classList.add('veluna-image-loaded');
              observer.unobserve(img);
            }
          }
        });
      }, {
        rootMargin: '50px'
      });
      
      // Observe all images with data-src
      document.querySelectorAll('img[data-src]').forEach(function(img) {
        imageObserver.observe(img);
      });
    }
    
    // ===== TRUST SECTION: VIDEO TESTIMONIALS =====
    var videoWrappers = document.querySelectorAll('.veluna-trust__video-wrapper');
    videoWrappers.forEach(function(wrapper) {
      var playButton = wrapper.querySelector('.veluna-trust__video-play');
      var video = wrapper.querySelector('.veluna-trust__video');
      var iframe = wrapper.querySelector('.veluna-trust__video-iframe');
      
      if (playButton) {
        playButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Handle MP4 video
          if (video) {
            video.play().catch(function(error) {
              console.warn('Video play failed:', error);
            });
            wrapper.classList.add('playing');
          }
          
          // Handle YouTube/Vimeo iframe
          if (iframe) {
            // Enable autoplay by modifying iframe src
            var src = iframe.src;
            if (src.includes('youtube.com')) {
              iframe.src = src.replace('autoplay=0', 'autoplay=1');
            } else if (src.includes('vimeo.com')) {
              iframe.src = src.replace('autoplay=0', 'autoplay=1');
            }
            wrapper.classList.add('playing');
          }
        });
      }
    });
    
    // ===== PERFORMANCE: Preload critical resources =====
    var preloadCritical = function() {
      // Preload hero image if exists
      var heroImage = document.querySelector('.veluna-hero__image img, .veluna-hero__media img');
      if (heroImage && heroImage.src) {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = heroImage.src;
        document.head.appendChild(link);
      }
    };
    preloadCritical();
  });
  
  // ===== TRUST SIGNALS: Real-time purchase notifications =====
  // DISABLED - Paused purchase notifications
  (function() {
    return; // Exit early - notifications disabled
    // 500 diverse names for purchase notifications
    var names = ['Aaliyah','Aaron','Abby','Abdul','Abel','Abigail','Abraham','Ada','Adam','Addison','Adeline','Adrian','Adriana','Adrienne','Aiden','Aimee','Alan','Alana','Albert','Alejandro','Alex','Alexa','Alexander','Alexandra','Alexandria','Alexis','Alfred','Alice','Alicia','Alisha','Alison','Allan','Allen','Allison','Alma','Alyssa','Amanda','Amber','Amelia','Amina','Amos','Amy','Ana','Andrea','Andrew','Andy','Angel','Angela','Angelica','Angelina','Angie','Anita','Ann','Anna','Annabelle','Anne','Annette','Annie','Anthony','Antonio','April','Ariana','Arianna','Ariel','Arlene','Arnold','Arthur','Arturo','Ashley','Ashlyn','Ashton','Aubrey','Audrey','Austin','Autumn','Ava','Avery','Bailey','Barbara','Barry','Beatrice','Becky','Belinda','Benjamin','Bennett','Benny','Bernard','Bernice','Bert','Bertha','Bessie','Beth','Bethany','Betty','Beverly','Bill','Billie','Billy','Blake','Blanca','Blanche','Bob','Bobbie','Bobby','Bonnie','Brad','Bradley','Brandi','Brandon','Brandy','Brenda','Brendan','Brent','Brett','Brian','Briana','Brianna','Bridget','Brittany','Brooke','Brooklyn','Bruce','Bryan','Bryant','Bryce','Byron','Caitlin','Caleb','Calvin','Cameron','Camila','Camille','Candace','Candice','Carl','Carla','Carlos','Carlton','Carmen','Carol','Caroline','Carolyn','Carrie','Carson','Casey','Cassandra','Cassidy','Cassie','Catherine','Cathy','Cecil','Cecilia','Cedric','Celeste','Celia','Chad','Charlene','Charles','Charlie','Charlotte','Chase','Chelsea','Cheryl','Chester','Chloe','Chris','Christian','Christie','Christina','Christine','Christopher','Christy','Cindy','Claire','Clara','Clarence','Clarissa','Clark','Claudia','Clay','Clayton','Clifford','Clifton','Clint','Clinton','Clyde','Cody','Cole','Colin','Colleen','Connie','Connor','Constance','Cora','Corey','Cornelius','Cory','Courtney','Craig','Crystal','Curtis','Cynthia','Daisy','Dakota','Dale','Dallas','Damian','Damien','Damon','Dan','Dana','Daniel','Danielle','Danny','Daphne','Darlene','Darrell','Darren','Darryl','Daryl','Dave','David','Dawn','Dean','Deanna','Debbie','Deborah','Debra','Dee','Delbert','Delia','Delores','Denise','Dennis','Derek','Derrick','Desiree','Devin','Devon','Dewayne','Diana','Diane','Dianna','Dianne','Dillan','Dillon','Dina','Dolores','Dominic','Dominique','Don','Donald','Donna','Donnie','Dora','Doreen','Doris','Dorothy','Doug','Douglas','Duane','Dustin','Dwayne','Dwight','Dylan','Earl','Earnest','Ebony','Ed','Eddie','Edgar','Edith','Edmond','Edmund','Edna','Eduardo','Edward','Edwin','Eileen','Elaine','Eleanor','Elena','Eli','Elias','Elijah','Elisabeth','Elise','Eliza','Elizabeth','Ella','Ellen','Ellie','Elliott','Ellis','Elmer','Eloise','Elsa','Elsie','Elton','Elvira','Elvis','Elyse','Emily','Emma','Emmanuel','Emmett','Eric','Erica','Ericka','Erik','Erika','Erin','Ernest','Ernesto','Ervin','Esmeralda','Esperanza','Estelle','Esther','Ethan','Ethel','Eugene','Eunice','Eva','Evan','Evelyn','Everett','Faith','Fannie','Faye','Felipe','Felix','Fernando','Flora','Florence','Floyd','Forrest','Fran','Frances','Francesca','Francine','Francis','Francisco','Frank','Frankie','Franklin','Fred','Freddie','Frederick','Fredrick','Gabriel','Gabriela','Gabriella','Gabrielle','Gail','Garrett','Garry','Gary','Gavin','Gay','Gayle','Gene','Geneva','Genevieve','Geoffrey','George','Georgia','Gerald','Geraldine','Gerard','Gerardo','Gertrude','Gideon','Gilbert','Gina','Ginger','Gladys','Glen','Glenda','Glenn','Gloria','Gordon','Grace','Grady','Grant','Greg','Gregg','Gregory','Gretchen','Griffin','Guadalupe','Guillermo','Gwendolyn','Haley','Hank','Hannah','Harold','Harriet','Harrison','Harry','Harvey','Hattie','Hazel','Heather','Hector','Heidi','Helen','Henry','Herbert','Herman','Hillary','Hilda','Holly','Hope','Howard','Hubert','Hugh','Hunter','Ian','Ida','Ignacio','Imani','Iris','Irma','Irving','Isaac','Isabel','Isabella','Isabelle','Isaiah','Ismael','Ivan','Ivy','Jack','Jackie','Jackson','Jacob','Jacqueline','Jacquelyn','Jade','Jaden','Jaime','Jake','Jamal','Jame','James','Jamie','Jan','Jane','Janelle','Janet','Janice','Janie','Janine','Jared','Jasmine','Jason','Javier','Jay','Jayden','Jayne','Jean','Jeanette','Jeanne','Jeannette','Jeannie','Jeff','Jeffery','Jeffrey','Jenna','Jennie','Jennifer','Jenny','Jerald','Jeremiah','Jeremy','Jermaine','Jerome','Jerry','Jesse','Jessica','Jessie','Jesus','Jill','Jillian','Jim','Jimmie','Jimmy','Jo','Joan','Joann','Joanna','Joanne','Jocelyn','Jodi','Jody','Joe','Joel','Joey','John','Johnathan','Johnnie','Johnny','Jon','Jonathan','Jonathon','Jordan','Jordyn','Jorge','Jose','Josefina','Joseph','Josephine','Josh','Joshua','Josiah','Josie','Joy','Joyce','Juan','Juanita','Judith','Judy','Julia','Julian','Juliana','Julie','Juliet','Julio','June','Justin','Justine','Kaitlyn','Kara','Karen','Kari','Karin','Karina','Karl','Karla','Kasey','Kate','Katelyn','Katherine','Kathleen','Kathryn','Kathy','Katie','Katrina','Kay','Kayla','Kaylee','Keith','Kelley','Kelli','Kellie','Kelly','Kelsey','Kelvin','Ken','Kendall','Kendra','Kenneth','Kenny','Kent','Kenya','Kerry','Kevin','Kiara','Kim','Kimberley','Kimberly','Kirk','Kirsten','Krista','Kristen','Kristi','Kristie','Kristin','Kristina','Kristine','Kristopher','Kristy','Krystal','Kurt','Kyle','Kylie','Lacey','Lamar','Lance','Lana','Landon','Lane','Lara','Larry','Latasha','Latoya','Laura','Laurel','Lauren','Laurence','Laurie','Laverne','Lawrence','Leah','Lee','Leigh','Lela','Lena','Leo','Leon','Leona','Leonard','Leroy','Lesley','Leslie','Lester','Leticia','Lewis','Lila','Lillian','Lillie','Lily','Linda','Lindsay','Lindsey','Lionel','Lisa','Lloyd','Logan','Lois','Lola','Lonnie','Lora','Lorena','Lorene','Lorenzo','Loretta','Lori','Lorraine','Lou','Louie','Louis','Louisa','Louise','Lowell','Luann','Lucas','Lucia','Lucille','Lucy','Luis','Luke','Lula','Luther','Lydia','Lyle','Lynda','Lynette','Lynn','Lynne','Mabel','Mable','Mack','Mackenzie','Macy','Madeline','Madelyn','Madison','Mae','Maggie','Malcolm','Malinda','Mallory','Mamie','Manuel','Manuela','Marc','Marcella','Marcia','Marco','Marcos','Marcus','Margaret','Margarita','Margie','Maria','Marian','Marianne','Marie','Marilyn','Marina','Mario','Marion','Marisa','Marissa','Marjorie','Mark','Marlene','Marlon','Marsha','Marshall','Martha','Martin','Marty','Marvin','Mary','Maryann','Mason','Mathew','Matilda','Matt','Matthew','Mattie','Maureen','Maurice','Mavis','Max','Maxine','Maxwell','May','Maya','Megan','Meghan','Melanie','Melba','Melinda','Melissa','Melody','Melvin','Mercedes','Meredith','Merle','Micah','Michael','Micheal','Michele','Michelle','Mickey','Miguel','Mike','Mildred','Miles','Millicent','Millie','Milton','Mindy','Minnie','Miranda','Miriam','Misty','Mitchell','Molly','Mona','Monica','Monique','Monroe','Montana','Monte','Monty','Morgan','Morris','Moses','Muriel','Myra','Myrtle','Nadine','Nancy','Naomi','Natalie','Natasha','Nathan','Nathaniel','Neal','Neil','Nellie','Nelson','Nettie','Nicholas','Nichole','Nick','Nicolas','Nicole','Nikki','Nina','Noah','Noel','Noelle','Nolan','Nora','Norma','Norman','Olivia','Ollie','Omar','Opal','Ora','Orlando','Oscar','Otis','Owen','Paige','Pam','Pamela','Parker','Pat','Patricia','Patrick','Patsy','Patti','Patty','Paul','Paula','Paulette','Pauline','Pearl','Pearlie','Pedro','Peggy','Penny','Perry','Pete','Peter','Philip','Phillip','Phyllis','Piper','Polly','Preston','Priscilla','Quincy','Quinn','Quinton','Rachel','Rafael','Ralph','Ramona','Randal','Randall','Randolph','Randy','Raquel','Raul','Ray','Raymond','Reagan','Rebecca','Rebekah','Reed','Reginald','Reid','Rene','Renee','Rex','Rhonda','Ricardo','Rich','Richard','Rick','Rickey','Ricky','Riley','Rita','Rob','Robbie','Robert','Roberta','Roberto','Robin','Rochelle','Rocky','Rod','Rodney','Rodolfo','Rodrigo','Roger','Roland','Rolando','Roman','Ron','Ronald','Ronnie','Roosevelt','Rosa','Rosalee','Rosalie','Rosalind','Rose','Rosemarie','Rosemary','Rosie','Ross','Roxanne','Roy','Ruben','Ruby','Rudolph','Rudy','Rufus','Russell','Rusty','Ruth','Ryan','Sabrina','Sadie','Sally','Salvador','Sam','Samantha','Sammie','Sammy','Samuel','Sandra','Sandy','Santiago','Sara','Sarah','Saul','Savannah','Scarlett','Scott','Sean','Selena','Serena','Sergio','Seth','Shannon','Shari','Sharon','Shaun','Shawn','Shawna','Sheila','Shelby','Sheldon','Shelia','Shelley','Shelly','Sheri','Sherri','Sherry','Sheryl','Shirley','Sidney','Sierra','Silvia','Simon','Skylar','Sonia','Sonja','Sonya','Sophia','Sophie','Spencer','Stacey','Staci','Stacie','Stacy','Stanley','Stefan','Stella','Stephan','Stephanie','Stephen','Steve','Steven','Stevie','Stewart','Stuart','Sue','Summer','Susan','Susanna','Susie','Suzanne','Sylvester','Sylvia','Tabitha','Tamara','Tami','Tammie','Tammy','Tanner','Tanya','Tara','Taylor','Ted','Teddy','Terence','Teresa','Terrance','Terrell','Terrence','Terri','Terrie','Terry','Tessa','Thelma','Theodore','Theresa','Thomas','Tiffany','Tim','Timmy','Timothy','Tina','Toby','Todd','Tom','Tomas','Tommie','Tommy','Toni','Tonia','Tony','Tonya','Tracey','Traci','Tracie','Tracy','Travis','Trent','Trevor','Tricia','Trina','Trinity','Trisha','Troy','Trudy','Tucker','Tyler','Tyrone','Ulysses','Valerie','Van','Vanessa','Velma','Vera','Verna','Vernon','Veronica','Vicki','Vickie','Vicky','Victor','Victoria','Vincent','Viola','Violet','Virgil','Virginia','Vivian','Wade','Wallace','Wanda','Warren','Wayne','Wendell','Wendy','Wesley','Whitney','Wilber','Wilbert','Wilbur','Wilfred','Wilfredo','Will','Willa','Willard','William','Willie','Willis','Wilma','Wilson','Winston','Woodrow','Wyatt','Xavier','Yolanda','Yvette','Yvonne','Zachary','Zelma','Zoe'];
    
    // Top 50 Tier 1 US cities
    var cities = ['New York, NY','Los Angeles, CA','Chicago, IL','Houston, TX','Phoenix, AZ','Philadelphia, PA','San Antonio, TX','San Diego, CA','Dallas, TX','San Jose, CA','Austin, TX','Jacksonville, FL','Fort Worth, TX','Columbus, OH','Charlotte, NC','San Francisco, CA','Indianapolis, IN','Seattle, WA','Denver, CO','Washington, DC','Boston, MA','Nashville, TN','El Paso, TX','Detroit, MI','Portland, OR','Las Vegas, NV','Memphis, TN','Louisville, KY','Baltimore, MD','Milwaukee, WI','Albuquerque, NM','Tucson, AZ','Fresno, CA','Sacramento, CA','Mesa, AZ','Kansas City, MO','Atlanta, GA','Omaha, NE','Colorado Springs, CO','Raleigh, NC','Miami, FL','Long Beach, CA','Virginia Beach, VA','Oakland, CA','Minneapolis, MN','Tampa, FL','Tulsa, OK','Arlington, TX','New Orleans, LA','Wichita, KS'];
    
    // Generate 500 unique notification combinations
    var notifications = [];
    for (var i = 0; i < 500; i++) {
      notifications.push({
        name: names[Math.floor(Math.random() * names.length)],
        location: cities[Math.floor(Math.random() * cities.length)],
        time: (Math.floor(Math.random() * 30) + 1) + ' minutes ago'
      });
    }
    
    var showNotification = function() {
      var notification = notifications[Math.floor(Math.random() * notifications.length)];
      var notificationEl = document.querySelector('.veluna-purchase-notification');
      if (notificationEl) {
        notificationEl.innerHTML = '<span class="veluna-purchase-notification__name">' + 
          notification.name + '</span> from <span class="veluna-purchase-notification__location">' + 
          notification.location + '</span> just purchased';
        notificationEl.classList.add('veluna-purchase-notification--visible');
        
        setTimeout(function() {
          notificationEl.classList.remove('veluna-purchase-notification--visible');
        }, 5000);
      }
    };
    
    // Show notification every 15-30 seconds (random)
    setInterval(function() {
      if (Math.random() > 0.7) { // 30% chance
        showNotification();
      }
    }, 15000);
  })();
  
  // ===== FOOTER EMAIL CAPTURE (Path 1: native only) =====
  // #VelunaFooterEmailCapture is {% form 'customer' %} in footer.liquid. No JS intercept:
  // form submits natively to Shopify /contact → Shopify creates customer → MailerLite app syncs.
  // No addEventListener: avoids double POST, fetch failures, and "Something went wrong" banner.
})();

